module.exports = __webpack_public_path__ + "static/media/3.d13854e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/3.jpg
// module id = 362
// module chunks = 0